import { CHILLNN_ROOM_RANK_PLAN_ID, ROOM_RATE_PLAN_ID } from "./constants";

export const isPseudoPlanID = (planID: string): boolean =>
	planID === CHILLNN_ROOM_RANK_PLAN_ID || planID === ROOM_RATE_PLAN_ID;
